import { ReactNode } from 'react'

import styled from 'styled-components'
import { twMerge } from 'tailwind-merge'

const RenderedRichTextContainer = styled.div`
  padding: 0;
  h1 {
    font-size: 2em;
  }
  h2 {
    font-size: 1.5em;
  }
  h3 {
    font-size: 1.17em;
  }
  h4 {
    font-size: 1em;
  }
  h5 {
    font-size: 0.83em;
  }
  h6 {
    font-size: 0.67em;
  }
  ul {
    display: flex;
    flex-direction: column;
  }
  ol {
    display: flex;
    flex-direction: column;
  }
  ol li {
    margin-bottom: 0.5em;
  }
  p {
    margin: 0;
  }
`

type Props = {
  children: ReactNode
  className?: string
}
const RenderedRichTextInput = ({ children, className }: Props) => {
  if (!children) {
    return
  }

  return (
    <RenderedRichTextContainer
      dangerouslySetInnerHTML={{ __html: children }}
      className={twMerge(
        `ql-editor [&_a]:!text-link [&_a]:hover:!underline [&_a]:focus-visible:!underline`,
        className
      )}
    ></RenderedRichTextContainer>
  )
}

export default RenderedRichTextInput
